<template>
    <div class="statistics-page">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-date-picker v-model="SearchDate" type="daterange" align="right"
                    unlink-panels
                    size="small"
                    range-separator="至"
                    start-placeholder="创建日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    @change="getCountData">
                </el-date-picker>
            </div>
        </div>
        <!-- 统计模块容器：循环渲染所有业务模块 -->
        <div class="statistics-container">
            <div class="statistics-module" v-for="(module, moduleKey) in countList" :key="moduleKey">
                <!-- 每个模块的标题 -->
                <div class="module-title">
                    <span>{{ module.name }}</span> 
                    <span class="module-futitle">项目数量 <span class="Red">{{module.system_total}}</span></span>
                </div>
                <!-- 模块内的状态统计卡片列表 -->
                <div class="status-card-wrap">
                    <div class="status-card" v-for="(item, index) in module.data" :key="index"
                        :class="{ active: item.total > 0 }">
                        <div class="status-text">{{ item.sq_status_name }}</div>
                        <div class="status-count">{{ item.total }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DataStatistics',
        data() {
            return {
                countList: {} ,// 渲染用的统计数据对象
                SearchDate:[],
                pickerOptions: {
                  shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近一个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近三个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                      picker.$emit('pick', [start, end]);
                    }
                  }]
                },
            }
        },
        created() {
            // 初始化加载数据
            this.getCountData()
        },
        methods: {
            // 初始化统计数据，和你的数据结构完美匹配
            getCountData() {
                this.$get('/api/expert_portal/count',{
                    start_time:this.SearchDate[0]||'',
                    end_time:this.SearchDate[1]||'',
                }).then(res => {
                    if (res) {
                        this.countList = res.data.list;
                    }
                })
            }
        }
    }
</script>

<style scoped>
    /* 页面全局样式 */
    .statistics-page {
        box-sizing: border-box;
    }

    /* 主标题样式 */
    .main-title {
        font-size: 20px;
        font-weight: 700;
        color: #2c3e50;
        margin-bottom: 28px;
        padding-left: 10px;
        border-left: 5px solid #2772e8;
    }

    /* 模块容器：上下排列模块，间距合理 */
    .statistics-container {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    /* 单个业务模块样式 */
    .statistics-module {
        background: #ffffff;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        border: 1px solid #f0f2f5;
    }

    /* 模块标题样式 */
    .module-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 18px;
        padding-bottom: 8px;
        border-bottom: 1px dashed #e5e7eb;
    }
    .module-futitle{
        font-size: 14px;
        font-weight: 500;
        padding-left: 10px;
    }
    /* 状态卡片容器：弹性布局，自适应换行 */
    .status-card-wrap {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        justify-content: flex-start;
    }

    /* 核心：单个状态卡片样式 */
    .status-card {
        flex: 1;
        min-width: 110px;
        max-width: 150px;
        height: 115px;
        background: #f8fafc;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: 1px solid #e2e8f0;
        transition: all 0.3s ease-in-out;
    }

    /* 鼠标悬浮卡片效果 */
    .status-card:hover {
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba(39, 114, 232, 0.1);
    }

    /* 有数值(total>0)的卡片高亮样式【重点】 */
    .status-card.active {
        background: #eff6ff;
        border-color: #2772e8;
    }

    /* 状态名称文字 */
    .status-text {
        font-size: 15px;
        color: #64748b;
        margin-bottom: 10px;
    }

    /* 状态统计数值（放大突出） */
    .status-count {
        font-size: 26px;
        font-weight: bold;
        color: #1e293b;
    }

    /* 高亮卡片的文字和数值颜色变化 */
    .status-card.active .status-text {
        color: #2772e8;
    }

    .status-card.active .status-count {
        color: #165dcf;
    }
</style>